import { render, staticRenderFns } from "./Render.vue?vue&type=template&id=5b845fc5&scoped=true&"
import script from "./Render.vue?vue&type=script&lang=js&"
export * from "./Render.vue?vue&type=script&lang=js&"
import style0 from "./Render.css?vue&type=style&index=0&id=5b845fc5&prod&scoped=true&lang=css&"
import style1 from "../Stampa/Print.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b845fc5",
  null
  
)

export default component.exports